import styled from 'vue-styled-components';

const wrapperProps = {
	backgroundImage: {
		type: String,
		default: '',
	},
};


const wrapper = styled('div', wrapperProps)`
	background-image: url(${props => props.backgroundImage});
	background-color: ${props => props.theme.primaryColor};
	background-size: cover;
`;

export { wrapper as default };
